// Modules
import { DebugPanel } from '../../components';
import { useDebugLog } from '../../hooks';

const DebuggerContainer = () => {
  const { entries, clear, sendRaw } = useDebugLog();

  return <DebugPanel entries={entries} onClear={clear} onSendRaw={sendRaw} />;
};

export default DebuggerContainer;
